// extracted by mini-css-extract-plugin
export default {"error":"Error_error__pvQbU"};